import { ExpandMore, Translate } from "@mui/icons-material";
import { Button, Hidden, Menu, MenuItem } from "@mui/material";
import * as React from "react";
import { useCallback, useState } from "react";
export function LanguageSwitcher(props) {
    var _a;
    const { color, language, setLanguage, languages } = props;
    const [anchorEl, setAnchorEl] = useState();
    const handleSelectLanguage = useCallback((language) => {
        setLanguage(language);
        setAnchorEl(undefined);
    }, [setLanguage]);
    const { displayName } = (_a = languages.find(l => l.language == language)) !== null && _a !== void 0 ? _a : {};
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { color: color, startIcon: React.createElement(Translate, null), endIcon: React.createElement(ExpandMore, { fontSize: "small" }), onClick: (e) => setAnchorEl(e.currentTarget) },
            React.createElement(Hidden, { mdDown: true }, displayName || language.toLocaleUpperCase()),
            React.createElement(Hidden, { mdUp: true }, language.toLocaleUpperCase())),
        React.createElement(Menu, { open: Boolean(anchorEl), anchorEl: anchorEl, keepMounted: true, onClose: () => setAnchorEl(undefined) }, languages.map((l) => (React.createElement(MenuItem, { key: l.language, onClick: () => handleSelectLanguage(l.language) }, l.displayName))))));
}
//# sourceMappingURL=LanguageSwitcher.js.map